window.fpWhenGsap = function (callback) {
  if (typeof callback !== 'function') return;

  if (window.gsap) {
    callback();
    return;
  }

  document.addEventListener(
    'fp:gsap-ready',
    function onReady() {
      callback();
    },
    { once: true }
  );
};
